import { jsx as o } from "react/jsx-runtime";
import { a as i } from "../../../../floating-ui.react-SmaXvp4L.js";
import { cloneElement as n } from "react";
import { s as l } from "../../../../MenuItem.module-Bj20OWCC.js";
import { useMenuComposite as p } from "../../hooks/useMenuComposite.js";
const I = (t, s) => {
  const m = p();
  if (!t)
    return null;
  const e = s === "listitem" ? /* @__PURE__ */ o("span", { role: "listitem", className: l.listItem, children: t }) : t;
  return m ? /* @__PURE__ */ o(i, { render: (r) => n(e, r) }) : e;
};
export {
  I as useMenuItemComposite
};
